import React from 'react'
import { CombinedInsuranceSelector } from '../../Global/CombinedInsuranceSelector'
import { getProductPrice } from '../../../utilities/combined-common'
import PropTypes from 'prop-types'

export const CombinedAccordionNew = ({
  components, 
  dispatch, 
  userData, 
  showAdditionalCoverage,
  values,
  setValues,
  accordion,
  basketList
}) => {

  const initialCheckedState = components.reduce((acc, item) => {
    const insurance = item.id
    acc[item.name] = userData[insurance];
    return acc
  }, {})

  const getExpandState = (initialCheckedState) => {
    const expand = {}
    let firstTrueFound = false

    for (const [key, value] of Object.entries(initialCheckedState)) {
      if(value && !firstTrueFound) {
        expand[key] = true
        firstTrueFound = true
      }
      else {
        expand[key] = false 
      }
    }

    return(expand)
  }

  const initialExpandedState = getExpandState(initialCheckedState)

  return (
    <div>
      <CombinedInsuranceSelector 
        components={components} 
        dispatch={dispatch} 
        initialCheckedState={initialCheckedState}
        initialExpandedState={initialExpandedState}
        getExpandState={(checkedState) => getExpandState(checkedState)}
        getPrice={(product) => getProductPrice(product, userData)}
        accordion={accordion}
        showAdditionalCoverage={showAdditionalCoverage}
        values={values}
        setValues={setValues}
        basketList={basketList}
        userData={userData}
      />
    </div>
  )
}

CombinedAccordionNew.propTypes = {
  components: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  userData: PropTypes.object.isRequired,
  accordion: PropTypes.bool.isRequired,
  showAdditionalCoverage: PropTypes.bool.isRequired,
  values: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  basketList: PropTypes.array.isRequired,
};